export const fallbackUrls = {
    "/womenwear/kolgoty/": "/womenwear/",
    "/womenwear/kupalniki/": "/womenwear/swimsuits/",
    "/womenwear/trusy/": "/womenwear/",
    "/detskaya-odezhda/rasprodazha-bluzok/": "/detskaya-odezhda/",
    "/promotion/1552/": "/"
}